import Image from "next/image";
import Link from "@/components/ui/Link";
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface WelcomeToPracticeData {
  subheading?: {
    text?: string;
    title?: string;
  };
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
  image?: {
    alt: string;
    image_file: {
      image: {
        id: string;
        filename_download: string;
      };
    };
  };
}

export const fields = [
  "subheading.text",
  "heading.text",
  "subheading.title",
  "heading.title",
  "text.text",
  "button.label",
  "button.href",
  "image.alt",
  "image.image_file.image.id",
  "image.image_file.image.filename_download"
] as const;

interface WelcomeToPracticeProps {
  data: WelcomeToPracticeData;
}

export default function WelcomeToPractice({ data }: WelcomeToPracticeProps) {
  const imageUrl = getReadableImageUrl(
    data?.image?.image_file?.image?.id || "",
    data?.image?.image_file?.image?.filename_download || ""
  );

  return (
		<section className='WelcomeToPractice py-16'>
			<div className='container'>
				<div className='flex flex-col lg:flex-row lg:space-x-8 mx-auto justify-center md:gap-16 lg:items-stretch'>
					<div className='order-2 lg:order-1 w-full lg:w-1/2 md:mb-8 lg:mb-0 relative flex flex-wrap content-between'>
						<div>
							{data?.subheading && (
								<div className='font-aileron font-bold text-sm uppercase tracking-wider text-secondary-dark mb-4 text-[#141A4C]'>
									{data.subheading.title || data.subheading.text}
								</div>
							)}
							{data?.heading && (
								<h2>
									{data.heading.title || data.heading.text}
								</h2>
							)}
							{data?.text && (
								<div
									className='grid gap-6 2xl:[&>p]:text-xl'
									dangerouslySetInnerHTML={sanitizeHTML(data.text.text || '')}
								/>
							)}
						</div>
						<div className='w-full'>
							{data?.button && (
								<div className='mt-6 text-left w-full'>
									<Link className='btn' href={data.button.href || ''}>
										{data.button.label}
									</Link>
								</div>
							)}
						</div>
					</div>
				<div className='order-1 lg:order-2 w-full lg:w-1/2 mb-8 lg:mb-0'>
					{data?.image && imageUrl && (
						<div className='relative w-full h-full min-h-[250px] lg:min-h-[400px] overflow-hidden'>
								<Image
									src={imageUrl}
									alt={data.image.alt || ''}
									fill
									quality={95}
									loading='lazy'
									className='object-cover'
									sizes='(min-width: 1024px) 50vw, 100vw'
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	)
}
